import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { SortOrder } from "primereact/api";
import findFaturamento from "../../service/findFaturamento";


export default function FaturamentoCadastrar({onClose, onSave}:{onClose: () => void, onSave: (faturamneto:any) => void}) {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const defaultValues = {
    dataReferencia: null,
    dataInicio: null,
    dataFim: null,
    dataVencimento: null,
    juros: null as number | null,
    multa: null as number | null,
    percentualImposto: null as number | null,
    instrucoes: '',
    assuntoEmail: '',
    textoEmail: ''
  };


  const {
      control,
      formState: { errors},
      handleSubmit,
      setValue
  } = useForm({ defaultValues });

  const onSubmit = (data:any) => {
      data.dataReferencia && save(data);
  };

  const copiarTag = (tag: string) => {
    navigator.clipboard.writeText(tag);
    toast.current?.show({ severity: 'success', summary: 'Copiado', detail: `Tag ${tag} copiada!`, life: 2000 });
  };


  const save = (data:any) => {
    const fat = {
      dataReferencia:data.dataReferencia,
      dataInicio:data.dataInicio,
      dataFim:data.dataFim,
      dataVencimento:data.dataVencimento,
      juros:data.juros,
      multa:data.multa,
      percentualImposto:data.percentualImposto,
      instrucoes:data.instrucoes,
      assuntoEmail:data.assuntoEmail,
      textoEmail:data.textoEmail
    }
    window.scrollTo(0, 0);
    onSave(fat);
  }

  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  useEffect(() => {
    const lazy = {
        first: 0,
        rows: 1,
        page: 1,
        data: null,
        status: null,
        sortField: 'dataFim',
        sortOrder: SortOrder.DESC
    };
    findFaturamento(lazy).then(data => {
      const anterior = data.faturamentos[0];
      const dataInicio = anterior.dataFim;
      dataInicio.setDate(dataInicio.getDate() + 1);
      setValue('dataInicio',dataInicio);
      if (anterior.juros != null) setValue('juros', anterior.juros);
      if (anterior.multa != null) setValue('multa', anterior.multa);
      if (anterior.percentualImposto != null) setValue('percentualImposto', anterior.percentualImposto);
      if (anterior.instrucoes) setValue('instrucoes', anterior.instrucoes);
      if (anterior.assuntoEmail) setValue('assuntoEmail', anterior.assuntoEmail);
      if (anterior.textoEmail) setValue('textoEmail', anterior.textoEmail);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const tags = [
    { tag: '#nomeCliente#', descricao: 'Nome do cliente' },
    { tag: '#valor#', descricao: 'Valor da fatura' },
    { tag: '#referencia#', descricao: 'Referência fatura' },
    { tag: '#vencimento#', descricao: 'Vencimento da fatura' }
  ];

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <Toast ref={toast} />
        <div>
          <div className="grid">
              <div className="col ">

                  <Controller
                      name="dataReferencia"
                      control={control}
                      rules={{ required: 'Data Referência é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataReferencia })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="dataReferencia" className="font-bold block mb-2 required">{t('dataReferencia')} </label>
                                <Calendar maxDate={new Date()} id='data' value={field.value}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="mm/yy" locale='pt'/>
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />


              </div>
              <div className="col">
                <Controller
                      name="dataVencimento"
                      control={control}
                      rules={{ required: 'Data Vencimento é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataVencimento })}></label>
                              <span className="">
                              <div>
                              <label htmlFor="dataVencimento" className="font-bold block mb-2 required">{t('dataVencimento')} </label>
                              <Calendar minDate={new Date()} id='data' value={field.value}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />

              </div>
          </div>
          <div className="grid">
              <div className="col">

                  <Controller
                      name="dataInicio"
                      control={control}
                      rules={{ required: 'Data Início é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataInicio })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="dataInicio" className="font-bold block mb-2 required">{t('dataInicio')} </label>
                                <Calendar disabled={true} id='dataInicio' value={field.value}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />


              </div>
              <div className="col">
                <Controller
                      name="dataFim"
                      control={control}
                      rules={{ required: 'Data Fim é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataFim })}></label>
                              <span className="">
                              <div>
                              <label htmlFor="dataFim" className="font-bold block mb-2 required">{t('dataFim')} </label>
                              <Calendar id='dataFim' maxDate={new Date()} value={field.value}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />

              </div>
          </div>
          <div className="grid">
              <div className="col">
                  <Controller
                      name="juros"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.juros })}></label>
                              <span className="">
                                <div>
                                  <label htmlFor="juros" className="font-bold block mb-2">{t('juros')} </label>
                                  <InputNumber id={field.name} value={field.value} onValueChange={(e) => field.onChange(e.value)} mode="decimal" minFractionDigits={2} maxFractionDigits={4} min={0} suffix=" %" className={classNames({ 'p-invalid': fieldState.error })} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
              <div className="col">
                  <Controller
                      name="multa"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.multa })}></label>
                              <span className="">
                                <div>
                                  <label htmlFor="multa" className="font-bold block mb-2">{t('multa')} </label>
                                  <InputNumber id={field.name} value={field.value} onValueChange={(e) => field.onChange(e.value)} mode="decimal" minFractionDigits={2} maxFractionDigits={4} min={0} suffix=" %" className={classNames({ 'p-invalid': fieldState.error })} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
              <div className="col">
                  <Controller
                      name="percentualImposto"
                      control={control}
                      rules={{ required: 'Percentual Imposto é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.percentualImposto })}></label>
                              <span className="">
                                <div>
                                  <label htmlFor="percentualImposto" className="font-bold block mb-2 required">{t('percentualImposto')} </label>
                                  <InputNumber id={field.name} value={field.value} onValueChange={(e) => field.onChange(e.value)} mode="decimal" minFractionDigits={2} maxFractionDigits={4} min={0} suffix=" %" className={classNames({ 'p-invalid': fieldState.error })} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
          </div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                  <Controller
                      name="instrucoes"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.instrucoes })}></label>
                              <span className="">
                                <div>
                                  <label htmlFor="instrucoes" className="font-bold block mb-2">{t('instrucoes')} </label>
                                  <InputTextarea id={field.name} value={field.value} onChange={(e) => field.onChange(e.target.value)} rows={4} autoResize style={{ width: '100%' }} className={classNames({ 'p-invalid': fieldState.error })} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
          </div>
          <br></br>
          <div className="card p-3" style={{ border: '1px solid #dee2e6', borderRadius: '6px' }}>
            <h5 className="mt-0 mb-3">{t('email')}</h5>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                    <Controller
                        name="assuntoEmail"
                        control={control}
                        render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name} className={classNames({ 'p-error': errors.assuntoEmail })}></label>
                                <span className="">
                                  <div>
                                    <label htmlFor="assuntoEmail" className="font-bold block mb-2">{t('assuntoEmail')} </label>
                                    <InputText id={field.name} value={field.value} onChange={(e) => field.onChange(e.target.value)} style={{ width: '100%' }} className={classNames({ 'p-invalid': fieldState.error })} />
                                  </div>
                                </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
                </div>
            </div>
            
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                    <Controller
                        name="textoEmail"
                        control={control}
                        render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name} className={classNames({ 'p-error': errors.textoEmail })}></label>
                                <span className="">
                                  <div>
                                    <label htmlFor="textoEmail" className="font-bold block mb-2">{t('textoEmail')} </label>
                                    <Editor id={field.name} value={field.value} onTextChange={(e) => field.onChange(e.htmlValue)} style={{ height: '260px' }} className={classNames({ 'p-invalid': fieldState.error })} />
                                  </div>
                                </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
                </div>
            </div>
            <div className="grid">
            <div className="col p-fluid">
                <div style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '6px', padding: '0.75rem 1rem', marginTop: '0.5rem' }}>
                <span style={{ fontWeight: 600, fontSize: '0.85rem', color: '#495057', display: 'block', marginBottom: '0.4rem' }}>
                    <i className="pi pi-info-circle" style={{ marginRight: '0.4rem' }} />Tags disponíveis (clique para copiar):
                </span>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                    {tags.map((t) => (
                    <span
                        key={t.tag}
                        onClick={() => copiarTag(`${t.tag}`)}
                        style={{ backgroundColor: '#e3f2fd', borderRadius: '4px', padding: '0.25rem 0.6rem', fontSize: '0.8rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.3rem', transition: 'background-color 0.2s' }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#bbdefb')}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
                    >
                        <i className="pi pi-copy" style={{ fontSize: '0.7rem' }} />
                        <b>{`${t.tag}`}</b> {t.descricao}
                    </span>
                    ))}
                </div>
                </div>
            </div>
            </div>
          </div>

        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div>
    </form>

  )
}

